/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import TableChartIcon from '@mui/icons-material/TableChart';
import BoltIcon from '@mui/icons-material/Bolt';
import MemoryIcon from '@mui/icons-material/Memory';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Modules',
		pages: [
			{
				title: 'Sites Location',
				href: '/modules/sitesLocation',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: SettingsInputAntennaIcon
			},
			{
				title: 'Sites Location Generic',
				href: '/modules/sitesLocationGeneric',
				icon: SettingsInputAntennaIcon,
				roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
			},
			{
				title: 'Dataset Stats',
				href: '/datasetStats',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: ViewModuleIcon,
				children: [
					{
						title: 'PM Counters',
						href: '/datasetStats/dataStatistics_Counters'
					},
					{
						title: 'PM KPI',
						href: '/datasetStats/dataStatistics_KPI',
					},
					{
						title: 'PM Energy',
						href: '/datasetStats/dataStatistics_PMEnergy',
					},
					{
						title: 'CM',
						href: '/datasetStats/dataStatistics_CM',
					},
					{
						title: 'Energy Consumption',
						href: '/datasetStats/CanopyPM_EnergyConsumptionDashboard',
					},
				],
			},
			{
				title: 'Dataset Stats Generic',
				href: '/datasetStatsGeneric',
				roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
				icon: ViewModuleIcon,
				children: [
					{
						title: 'Energy Consumption Generic',
						href: '/datasetStatsGeneric/CanopyPM_EnergyConsumptionDashboard_GenericData',
					},
				],
			},
			{
				title: 'Algorithms',
				href: '/algorithms',
				icon: MemoryIcon,
				children: [
					{
						title: 'STTM Dashboard',
						href: '/algorithms/STTM_Algorithm',
					},
					{
						title: 'SRCA Dashboard',
						href: '/algorithms/SRCA_Algorithm',
					},
					{
						title: 'SPFM Dashboard',
						href: '/algorithms/SPFM_Algorithm',
					},
					{
						title: 'Capacity Management',
						href: '/algorithms/CapacityManagement',
					}
				],
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
			},
			{
				title: 'Algorithms Generic',
				href: '/algorithmsGeneric',
				icon: MemoryIcon,
				children: [
					{
						title: 'STTM Dashboard',
						href: '/algorithmsGeneric/STTM_Algorithm_GenericData',
					},
					{
						title: 'SRCA Dashboard',
						href: '/algorithmsGeneric/SRCA_Algorithm_GenericData',
					},
					{
						title: 'SPFM Dashboard',
						href: '/algorithmsGeneric/SPFM_Algorithm_GenericData',
					},
					{
						title: 'Capacity Management',
						href: '/algorithmsGeneric/CapacityManagement_GenericData',
					}
				],
				roles: ['Administrator', 'Manager', 'Client', 'CelfinetOS'],
			},
			{
				title: 'Dataset Export',
				href: '/datasetExport',
				icon: TableChartIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'Client', 'CelfinetOS'],
			},
			{
				title: 'Energy Watchdog',
				href: '/energyWatchdog',
				icon: BoltIcon,
				children: [
					{
						title: 'Canopy',
						href: '/energyWatchdog/Canopy',
					},
					{
						title: 'EW',
						href: '/energyWatchdog/EW',
					},
					{
						title: 'VFPT',
						href: '/energyWatchdog/VFPT',
					}
				],
				roles: ['Administrator', 'Manager', 'CelfinetHQ'], // , 'Client', 'CelfinetOS'
			},
			{
				title: 'Energy Watchdog Gen.',
				href: '/energyWatchdogGeneric',
				icon: BoltIcon,
				children: [
					{
						title: 'Canopy (Generic)',
						href: '/energyWatchdogGeneric/Canopy',
					},
					{
						title: 'EW (Generic)',
						href: '/energyWatchdogGeneric/EW',
					},
					{
						title: 'VFPT (Generic)',
						href: '/energyWatchdogGeneric/VFPT',
					}
				],
				roles: ['Administrator', 'Manager', 'CelfinetHQ'], // , 'Client', 'CelfinetOS'
			},
		],
	},
	{
		roles: ['Administrator', 'Manager'],
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				roles: ['Administrator', 'Manager'],
				icon: SettingsIcon
			},
		],
	},
];
